import React, { useContext } from 'react';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { Link, useNavigate } from 'react-router-dom';
import { SiteContext } from '../../../context/SiteContext';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { PageAbsolutePath } from '../../../consts/Common';

const ExcessReturnPolicyTermsConditions = (): JSX.Element => {
  const navigate = useNavigate();

  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandDisplayName, brandPhoneNumbers } = brand;

  const phoneNumber = brandPhoneNumbers.claimsNumber;

  const goBack = (): void => {
    navigate(-1);
  };

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  return (
    <div className='excess-terms-conditions'>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h4>Excess Return Policy Terms and Conditions</h4>
      <p>
        Your Excess Return Policy Certificate of Insurance sets out, in summary,
        the terms and conditions of your cover. There are also exclusions and
        conditions that you must follow for the insurance to work. For full
        details please refer to the points below and the Excess Return Policy
        Document, available to download{' '}
        <Link
          id='lnkTermsOfBusiness'
          className='in-text'
          to={PageAbsolutePath.Insurance.PolicyDocuments}>
          here
        </Link>
        .
      </p>
      <h4>Cover</h4>
      <p>
        The Excess Return Policy enables you to recover all or part of your
        Motor Insurance Policy accidental damage excess, provided the claim is
        covered by your Motor Insurance Policy and settled fully by your Motor
        Insurer. Only claims arising from your Motor Insurance Policy after 30
        days of the Excess Return Policy start date will be covered. Glass
        claims and misfuelling claims are not covered by this policy.
      </p>
      <h4>Insurer</h4>
      <p>
        The Excess Return Policy is arranged by Car Care Plan Limited, which is
        registered in England, Company No. 850195 at Jubilee House, 5 Midpoint
        Business Park, Thornbury, West Yorkshire, BD3 7AG and authorised and
        regulated by the Financial Conduct Authority, No. 309268. It is
        underwritten by Fortegra Europe Insurance Company Ltd which is
        authorised by the Prudential Regulation Authority, is subject to
        regulation by the Financial Conduct Authority, and limited regulation by
        the Prudential Regulation Authority.
      </p>
      <h4>To make a claim</h4>
      <p>
        In the event of an accident, Call the {brandDisplayName} Excess Return
        team on
        <a className='calltext' href={`tel:${phoneNumber}`}>
          {phoneNumber}
        </a>
        before your Motor Insurer and as soon as possible following the
        occurrence of the event causing your claim. We'll give you cash back
        towards your policy excess, whoever you're insured by. You’ll also
        benefit from a {brandDisplayName} accident repair using only{' '}
        {brandDisplayName} genuine parts.
      </p>
      <ul>
        <li>
          Where we manage the vehicle repair, we will do so in conjunction with
          your Motor Insurer if the accident was your fault, or the at-fault
          party’s insurer if the at-fault party (referred to as the third party)
          has accepted liability. Some insurers may charge an additional excess
          for using our repairers.
        </li>
        <li>
          In some instances where your insurer may not let us report the claim
          to them on your behalf, we will ask you to report to them advising
          that you are using our {brandDisplayName} Excess Return service with a{' '}
          {brandDisplayName} accident repair
        </li>
        <li>
          {brandDisplayName} Excess Return team will arrange repair of the
          vehicle. You will be required to pay the repairer your normal Motor
          Insurance Policy Excess. Once the repair is complete, we will refund
          you in accordance with the limits set out in your Certificate of
          Insurance.
        </li>
        <li>
          Accident recovery is provided for unroadworthy vehicles when you call
          the {brandDisplayName} Excess Return team and we handle your insurance
          claim on your behalf. If you cancel the recovery of your vehicle you
          will be liable for any cancellation charges incurred, or if your
          insurer rejects your claim you will be liable for any recovery costs
          incurred.
        </li>
        <li>
          A replacement car is provided subject to availability for the duration
          of the accident repair carried out by a {brandDisplayName} approved
          bodyshop when you call the {brandDisplayName} Excess Return team and
          we handle your insurance claim on your behalf. We will provide a
          repairer courtesy car if the incident is your fault, or if the
          incident is not your fault, we will aim to provide a hire car of a
          similar size to your own vehicle. A replacement car is not available
          for standalone glass claims or if you are claiming on{' '}
          {brandDisplayName} Free Driveaway Insurance.
        </li>
        <li>
          Nothing in this offer obliges us to accept any vehicle for repair.
        </li>
      </ul>
      <p>
        Please note: The information stated is applicable if you have purchased
        an Excess Return Policy. If you have a free Excess Return Voucher,
        please refer to your Excess Return Voucher for details of your terms and
        conditions.
      </p>
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default ExcessReturnPolicyTermsConditions;
